namespace Application.Models {
    'use strict';

    export interface IClientInfo {
        result: IClientInfoResult;
    }

    export class ClientInfo implements IClientInfo {
        public result: IClientInfoResult;

        public static createEmpty(): ClientInfo {
            return new ClientInfo();
        }
    }

    export interface IClientInfoResult {
        temp: string;
        voltage: string;
        current: string;
        bandwidth: string;
        status: string;
    }
}